import type { CloudGraphCampaignEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI: CloudGraphCampaignEntityAti[] = [
	'ati:cloud:graph:campaign',
];
